var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"text-center":"","wrap":""}},[_c('div',{staticClass:"atc"},[_c('h1',{staticClass:"authenticating-title"},[_vm._v("Authenticating")]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#c42111","striped":"","height":"8"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }